import { useRef } from "react";
import useClickOutside from "../hooks/useClickOutside";
import SvgIcon from "./SvgIcon";
import PropTypes from "prop-types";

const DropdownOptions = ({
  options,
  onSelectFn,
  addIcon = false,
  opened = false,
  initialDropwdownState = {},
  setDropdownState,
  excludeOutsideClickElements,
  dropdownPosition,
}) => {
  const style = {
    top: dropdownPosition,
  };

  const dropdownRef = useRef(null);
  /**
   * Close the dropdown clicking outside
   */
  useClickOutside(
    dropdownRef,
    () => {
      setDropdownState(initialDropwdownState);
    },
    opened,
    excludeOutsideClickElements
  );

  /**
   * When the user selects the option
   * @param {*} option
   */
  const handleOptionClick = (option) => {
    onSelectFn(option.value);
  };

  return (
    <ul
      className={opened ? "opened dropdown-menu" : "dropdown-menu"}
      ref={dropdownRef}
      style={style}
    >
      {options.map((option, i) => (
        <li key={option.value} role="none">
          <button
            role="menuitem"
            onMouseDown={(e) => {
              e.preventDefault();
              handleOptionClick(option);
            }}
            onTouchEnd={(e) => {
              e.preventDefault();
              handleOptionClick(option);
            }}
          >
            <span>{option.label}</span>
            {addIcon && (
              <SvgIcon
                src="/img/new-icons/add.svg"
                alt="add"
                classNames="mobile-hidden"
              />
            )}
          </button>
        </li>
      ))}
    </ul>
  );
};

DropdownOptions.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.any.isRequired,
    })
  ).isRequired,
  onSelectFn: PropTypes.func.isRequired,
  addIcon: PropTypes.bool,
  opened: PropTypes.bool.isRequired,
  initialDropwdownState: PropTypes.object.isRequired,
  setDropdownState: PropTypes.func.isRequired,
  excludeOutsideClickElements: PropTypes.array,
  dropdownPosition: PropTypes.any,
};

export default DropdownOptions;
